import React, { useState } from "react";
import axios from "axios";
import { EyeIcon, EyeOffIcon } from "@heroicons/react/outline"; // Import Heroicons for eye icon

import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { apiUrl } from "../config/url";

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // State to manage password visibility
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${apiUrl}/account/adminLogin`, {
        username,
        password,
      });
      console.log(response);
      if (response.data.status === true) {
        localStorage.setItem("company_id", response.data.company_id);
        localStorage.setItem(
          "company_name",
          response.data.company_details.company_name
        );
        localStorage.setItem("full_name", response.data.full_name);
        localStorage.setItem("api_token", response.data.token);
        localStorage.setItem("user_role", response.data.user_role);
        localStorage.setItem("company_id", response.data.company_id);
        localStorage.setItem("user_id", response.data.user_id);


        toast("Login Successful", { type: "success" }); // Changed to show a relevant message
        setTimeout(() => {
          navigate("/Home");
        }, 1000); // Adjust the delay as needed (2000 ms = 2 seconds)
      } else {
        toast("Invalid Credentials", { type: "error" }); // Changed to show a relevant message
      }
    } catch (error) {
      toast("An error occurred. Please try again.", { type: "error" });
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <ToastContainer /> {/* Add ToastContainer here */}
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md transition-transform transform hover:scale-105">
        <h1 className="text-5xl font-bold text-center text-black-600 mb-6">
          Mahalaxmi Glass
        </h1>
        <h2 className="text-3xl font-bold text-center text-blue-600 mb-6">
          Login
        </h2>
        {error && <p className="text-red-500 mb-4 text-center">{error}</p>}
        <form onSubmit={handleLogin}>
          <div className="mb-6">
            <label className="block text-gray-700 mb-2" htmlFor="username">
              Username :
            </label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200"
              placeholder="Enter your username"
            />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 mb-2" htmlFor="password">
              Password :
            </label>
            <div className="relative flex items-center">
              <input
                type={showPassword ? "text" : "password"} // Toggle password visibility
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200"
                placeholder="Enter your password"
              />
              {/* Eye Icon for toggling password visibility inside the input field */}
              <span
                onClick={() => setShowPassword(!showPassword)}
                className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
              >
                {showPassword ? (
                  <EyeOffIcon className="w-5 h-5 text-gray-500" />
                ) : (
                  <EyeIcon className="w-5 h-5 text-gray-500" />
                )}
              </span>
            </div>
          </div>
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition duration-200"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
